var backendBase = 'https://2022.api.alba-festival.ch/';

export default  {
  backendBase: backendBase,
};
